var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-md-12",staticStyle:{"overflow":"auto"}},[_c('br'),_c('b-tabs',[_c('br'),_c('b-tab',{attrs:{"title":"Documents"}},[_c('Documents')],1),_c('b-tab',{attrs:{"title":"Profiles"}},[_c('Profiles')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }